module.exports = __webpack_public_path__ + "static/media/controlled-breathing@2x.f500c2b6.png";